import ko from 'knockout';
import templateMarkup from 'raw-loader!./tabbed-dashboard.template.html';
import $ from 'jquery';
import _ from 'lodash';
import Signals from 'signals';
import PermissionService from '../../services/permission.service';
import PreferenceService from '../../services/preference.service';
import PanelFactory from '../../app/panel-factory';
import DataProvider from '../../app/data-framework/data-provider';
import DashboardDataModel from '../dragdrop-grid/data/dashboard.model';
import DashboardDataService from '../dragdrop-grid/data/dashboard.service';
import AddPanelModal from '../../modules/assurance/dialogs/add-panel/add-panel'; // TODO: Genericize; not an assurance-only component
import DragDropGridService from '../dragdrop-grid/dragdrop-grid.service';
import UtilsService from '../../services/utils.service';
import '../tabs-list/tabs-list';
import '../dragdrop-grid/dragdrop-grid';
import '../share-panel-modal/share-panel-modal';
import '../share-panel-adv-modal/share-panel-adv-modal';
import LoginService from "../../services/login.service";

function TabbedDashboardVM(params) {
    var self = this;
    self.initialize(params);
}

// UI-1688: copied from dashboard-common
function makeObservableParams(panel) {
  var observableParamsList = [];
  var foundobsparam = false;
  panel.dataSources.forEach(function (dsItem) {

      if (dsItem.params.observableParams) {
          foundobsparam = true;
          if (dsItem.params.obsParamsInitValue) {
              observableParamsList.push(ko.observable(dsItem.params.obsParamsInitValue));
          }
          else {
              observableParamsList.push(ko.observable({}));
          }
      }
      else {
          observableParamsList.push({});
      }
  });

  if (!foundobsparam) {
      observableParamsList = [];
  }

  return observableParamsList;
};
// helper to save without getting circular object error
function getJsonFromComponent(component) {
    var panel = {
    height: component.height,
    width: component.width,
    x: component.x,
    y: component.y,
    id: component.id,
    params: {
      options: component.params.observableOptions()
    },
    type: component.componentType,
  };

    return panel;
};

function createHistorical2Panel(panelTemplateObj, panelOptions) {
  var panel = $.extend({}, panelTemplateObj);
  var options = $.extend({}, panelTemplateObj.defaultOptions, panelOptions);
  options.id = UtilsService.generateID();
  var newPanel = {
    id: options.id,
    type: panel.panelType,
    componentType: panel.panelType,
    height: panel.height,
    width: panel.width,
    params: {
      options: options
    },
    x: 32000,
    y: 32000,
    autoPosition: true
  };
  return newPanel;
}

// UI-2386: panels need access to all dashboards and corresponding tabs
function setDashboardsAndTabsList(self) {
  let appId = self.dashboardIds().appId;
  let dashboardsAndTabsList = [];
  let promises = [];

  let dashboardsMenuItem = ko.utils.arrayFirst(self.menus(), item => item.name.toLowerCase() === 'dashboards');
  if (dashboardsMenuItem) {
    let dashboardViews = dashboardsMenuItem.views;
    for (let i = 0, _i = dashboardViews.length; i < _i; i++) {
      dashboardsAndTabsList[i] = {
        name: dashboardViews[i].name,
        id: dashboardViews[i].id,
        viewId: dashboardViews[i].viewId,
        tabsList: []
      };
      promises.push(PreferenceService.getTabs(appId, dashboardViews[i].viewId, LoginService.userObject.userId));
    }

    Promise.all(promises).then(results => {
      for (let j = 0, _j = results.length; j < _j; j++) {
        dashboardsAndTabsList[j].tabsList = results[j];
      }
      self.dashboardsAndTabsList(dashboardsAndTabsList);
      /*
        format:
        [
          {
            name: [dashboardName],
            id: [dashboardId],
            tabsList: [
              {
                name: [tabName],
                id: [tabId]
              },
              {
                ...
              }
            ]
          },
          {
            ...
          }
        ]
      */
    });
  }
}

TabbedDashboardVM.prototype = {
    dispose: function () {
        var self = this;
        self.subscriptions.forEach(sub => sub.dispose());
        self.dataConsumers.forEach(function(consumerId) {
          self.dataProvider.unregisterDataConsumer(consumerId);
        });
        self.dataConsumers = [];
    },

    initialize: function (params) {
        var self = this;

        self.subscriptions = [];
        self.panelToTab = {};
        self.permissionService = new PermissionService(LoginService.userObject);

        if (_.isEmpty(params.appId) || _.isEmpty(params.viewId)) {
            throw new Error('TabbedDashboard :: Missing required parameters (appId, viewId).');
        }

        self.route = params.route;
        self.dashboardIds = ko.observable({
            appId: params.appId,
            viewId: ko.unwrap(params.viewId)
        });

        self.notificationBarText = ko.observable();
        self.notificationBar = document.querySelector('div.notification-bar');

        // only applies to historical2 views
        if (params.viewLevelOptions) {
            self.viewLevelOptions = params.viewLevelOptions;
        }

        self.disallowTabEditing = ko.observable(false);
        self.allowNewTab = ko.observable(false);
        self.disableDrag = ko.observable(true);
        handleRoute(self, self.route(), params);
        self.subscriptions.push(self.route.subscribe((route) => {
            if (ko.unwrap(params.viewId) === self.getDashboardIds().viewId) {
              handleRoute(self, route, params, true);
            }
        }));

        self.panelFactory = new PanelFactory();
        self.dataProvider = DataProvider.getInstance();

        self.dateRange = params.dateRange;

        self.dataConsumers = [];

        self.menus = params.menus || ko.observableArray([]);
        self.dashboardsAndTabsList = ko.observableArray([]);

        self.tabsList = ko.observableArray([]);
        self.panelsOA = params.panels || ko.observableArray([]);
        self.fixedPanels = params.fixedPanels || ko.observableArray([]);
        self.selectedDashboard = ko.observable();
        self.selectedTab = ko.observable();

        setDashboardsAndTabsList(self);

        //  tabs signals :: crUd
        self.selectedTabChanged = new Signals.Signal();
        self.tabRenamed = new Signals.Signal();
        self.tabAdded = new Signals.Signal();
        self.tabRemoved = new Signals.Signal();

        self.previouslyLoadedTab = {};
        self.selectedTabChanged.add((tabId) => {
            if (tabId) {
                self.loadTab(tabId);
            }
        });
        self.tabRenamed.add(self.saveRenameTab.bind(self));
        self.tabAdded.add(self.saveTabAdded.bind(self));
        self.tabRemoved.add(self.saveTabRemoved.bind(self));

        self.signals = {
            selectedTabChanged: self.selectedTabChanged,
            tabRenamed: self.tabRenamed,
            tabAdded: self.tabAdded,
            tabRemoved: self.tabRemoved,
        };

        //  panel signals :: CRUD
        self.panelDeleted = new Signals.Signal();
        self.panelOptionsUpdated = new Signals.Signal();
        self.panelPositionsUpdated = new Signals.Signal();
        self.resizeSignal = new Signals.Signal();
        self.clonePanel = new Signals.Signal();
        self.movePanel = new Signals.Signal();
        self.copyPanel = new Signals.Signal();
        self.copyPanelAdvanced = new Signals.Signal();

        self.panelDeleted.add(self.onPanelDeleted.bind(self));
        self.panelOptionsUpdated.add(self.onPanelOptionsUpdated.bind(self));
        self.panelPositionsUpdated.add(self.onPanelsPositionsUpdated.bind(self));
        self.clonePanel.add(self.onClonePanel.bind(self));
        self.movePanel.add(self.onMovePanel.bind(self));
        self.copyPanel.add(self.onCopyPanel.bind(self));
        self.copyPanelAdvanced.add(self.onCopyPanelAdvanced.bind(self));
        self.resizeSignal.add(_.noop);

        self.panelSignals = {
            panelDeleted: self.panelDeleted,
            panelOptionsUpdated: self.panelOptionsUpdated,
            panelPositionsUpdated: self.panelPositionsUpdated,
            resizeSignal: self.resizeSignal,
            clonePanel: self.clonePanel,
            movePanel: self.movePanel,
            copyPanel: self.copyPanel,
            copyPanelAdvanced: self.copyPanelAdvanced
        };

        self.dashboardDataModel = new DashboardDataModel();
        self.dashboardDataService = new DashboardDataService(self.dashboardDataModel);

        self.dashboardDataModel.panelsUpdated.add(function () {
            var panels = self.dashboardDataService.getPanels();
            self.internalSetPanels(panels);
        });

        var unwrap = self.getDashboardIds();
        PreferenceService
            .getViewPreferences(unwrap.appId, unwrap.viewId)
            .then(self.processViewPreferences.bind(self));

        // this function is invoked by historical2 AddPanels modal dialog when a panel is added
        self.addPanelCallback = function (panelTemplateObj, panelOptions) {
            // short circuit if permalink
            if (self.disallowTabEditing()) {
              return;
            }
            var newPanel = createHistorical2Panel(panelTemplateObj, panelOptions);
            var originalNodes = DragDropGridService.getNodePositions();

            self.createComponents([newPanel]).then((components) => {
                var component = components[0];
                delete component.autoPosition;
                let newPanels = self.panelsOA().slice(0)
                newPanels.push(component);
                self.setPanels(newPanels);
                var unwrap = self.getDashboardIds(component.id);
                if (!unwrap) return; // invalid panel id, skip the rest
                PreferenceService.addOrUpdatePanel(unwrap.appId,
                    unwrap.viewId,
                    unwrap.tabId,
                    component.id,
                    getJsonFromComponent(component))
                .then((result) => {
                    var updatedPanels = DragDropGridService.getNodePositionsDiff(originalNodes);
                    if (!_.isEmpty(updatedPanels)) {
                        self.onPanelsPositionsUpdated(updatedPanels);
                    }
                });
            });
        };

        // Calculate whether dropdowns should instead 'dropup' based on window dimensions: https://stackoverflow.com/a/33548516
        // TODO: should this code live somewhere else?
        $(document).on("shown.bs.dropdown", ".dropdown", function() {
          // calculate the required sizes, spaces
          var $ul = $(this).children(".dropdown-menu");
          var $contentWrapper = $(".content-wrapper");
          var $button = $(this).children(".dropdown-toggle");
          var ulOffset = $ul.offset();
          // TODO: Known bug -- for some reason on the initial open of the dropdown, $ul.height() returns the height of the full page instead of the ul element.
          //       On subsequent expansions the calculations appears correct. The dropdown is still fully functional with this bug, the affect is that sometimes
          //       the menu will be a 'dropup' when it doesn't necessarily need to be.

          // how much space would be left on the top if the dropdown opened that direction
          var spaceUp = (ulOffset.top - $button.height() - $ul.height()) - $contentWrapper.scrollTop();
          // how much space is left at the bottom
          var spaceDown = $contentWrapper.scrollTop() + $contentWrapper.height() - (ulOffset.top + $ul.height());
          // switch to dropup only if there is no space at the bottom AND there is space at the top, or there isn't either but it would be still better fit
          if (spaceDown < 0 && (spaceUp >= 0 || spaceUp > spaceDown))
            $(this).addClass("dropup");
        }).on("hidden.bs.dropdown", ".dropdown", function() {
          // always reset after close
          $(this).removeClass("dropup");
        });
    },

    loadTab: function () {
        let self = this;
        const route = self.route();

        if (!route.tabId || (self.previouslyLoadedTab.tabId === route.tabId && self.previouslyLoadedTab.view === route.view)) {
          // prevent double load
          return;
        }
        self.previouslyLoadedTab = route;

        const link = route.link;
        const tabId = route.tabId || "0";
        // hide previous panels while loading
        self.setPanels([]);
        if (!link) {
          var unwrap = self.getDashboardIds();
          unwrap.tabId = tabId;
          self.dashboardIds(unwrap);
          self.selectedTab(ko.utils.arrayFirst(self.tabsList(), tab => tab.id === tabId));
          self.dataConsumers.forEach(function(consumerId) {
              self.dataProvider.unregisterDataConsumer(consumerId);
          });
          self.dataConsumers = [];

          PreferenceService
            .getTabPreferences(unwrap.appId, unwrap.viewId, tabId)
            .then(self.processTabPreferences.bind(self));
          PreferenceService
            .getFixedPanels(unwrap.appId, unwrap.viewId, tabId)
            .then(self.processTabFixedPanels.bind(self));
        }
        // permalink route so fetch from link
        else {
          self.dataProvider
              .getTokenParams(link)
              .then(function (tokenParams) {
                  let panels = [];
                  // dashboards
                  if (tokenParams.tabprefs) {
                      let panelObject = tokenParams.tabprefs.panels;
                      Object.keys(panelObject).forEach((key) => {
                        let panel = panelObject[key];
                        panel.id = key;
                        panels.push(panel);
                      });
                      self.processTabPreferences(panels);
                  }
                  // datasets
                  else {
                      let WhereConditionObj =  tokenParams.WhereConditionObj;
                      let unwrap = self.getDashboardIds();
                      PreferenceService
                        .getFixedPanels(unwrap.appId, unwrap.viewId, tabId)
                        .then(self.processTabFixedPanels.bind(self));
                  }
              });
        }
    },

    addPanels(optionsSet) {
      var self = this;
      // short circuit if permalink
      if (self.disallowTabEditing()) {
        return;
      }
      var unwrap = self.getDashboardIds(); // todo
      var originalNodes = DragDropGridService.getNodePositions();
      var newPanels = self.dashboardDataService.addPanels(optionsSet);
      _.forEach(newPanels, function(panel) {
        delete panel.autoPosition;
      });

      PreferenceService.addOrUpdatePanels(unwrap.appId, unwrap.viewId, unwrap.tabId, newPanels);

      var updatedPanels = DragDropGridService.getNodePositionsDiff(originalNodes);
      if (!_.isEmpty(updatedPanels)) {
        self.onPanelsPositionsUpdated(updatedPanels);
      }
    },

    onClonePanel: function(panelOptions) {
      let self = this;
      self.addPanels([panelOptions]); // addPanels expects an array
    },

    onMovePanel: function(panelOptions, panelId, tab) {
      let self = this;
      // short circuit if permalink
      if (self.disallowTabEditing()) {
        return;
      }
      let unwrap = self.getDashboardIds();
      let newPanel = DashboardDataService.newPanel(panelOptions);
      delete newPanel.autoPosition;
      PreferenceService.addOrUpdatePanel(unwrap.appId, unwrap.viewId, tab.id, newPanel.id, newPanel).then(() => {
        self.onPanelDeleted(panelId).then(() => {
          self.notificationBarText(`"${newPanel.params.options.title}" Panel has been moved to "${tab.name}" Dashboard`);
          self.notificationBar.classList.add('show-notification-bar');
          setTimeout(() => { self.notificationBar.classList.remove('show-notification-bar'); }, 3000); // show for 3 seconds
        });
      });
    },

    onCopyPanel: function() {
      let self = this;
      let modal = ko.dataFor($('#share-panel-modal')[0].firstChild);
      let unwrap = self.getDashboardIds();

      modal.show({
        appId: unwrap.appId,
        viewId: unwrap.viewId
      });
    },

    onCopyPanelAdvanced: function() {
      let self = this;
      let modal = ko.dataFor($('#share-panel-adv-modal')[0].firstChild);
      let unwrap = self.getDashboardIds();

      modal.show({
        appId: unwrap.appId,
        viewId: unwrap.viewId
      });
    },

    onPanelDeleted: function (panelId) {
        var self = this;
        // short circuit if permalink
        if (self.disallowTabEditing()) {
          return;
        }
        var unwrap = self.getDashboardIds(panelId);
        if (!unwrap) return; // invalid panel id, skip the rest
        var originalNodes = DragDropGridService.getNodePositions();

        return PreferenceService
            .deletePanel(unwrap.appId, unwrap.viewId, unwrap.tabId, panelId)
            .then(function (results) {
                self.dashboardDataService.removePanel(panelId);

                var updatedPanels = DragDropGridService.getNodePositionsDiff(originalNodes);
                if (!_.isEmpty(updatedPanels)) {
                    self.onPanelsPositionsUpdated(updatedPanels);
                }
            });
    },

    onPanelOptionsUpdated: function (updatedOptions) {
        var self = this;
        // short circuit if permalink
        if (self.route().link) {
          return;
        }
        var found = _.find(ko.unwrap(self.panelsOA), ["id", updatedOptions.id]);

        if (found) {
            // found has already been updated just need to persist it
            var unwrap = self.getDashboardIds(updatedOptions.id);
            if (!unwrap) {
              // just get the default ids
              unwrap = self.getDashboardIds();
            }
            var newValue = {params: {options: updatedOptions.params.options}};
            if (updatedOptions.type) {
                newValue.type = updatedOptions.type;
                newValue.height = updatedOptions.height;
                newValue.width = updatedOptions.width;
            }
            PreferenceService
                .addOrUpdatePanel(unwrap.appId, unwrap.viewId, unwrap.tabId, updatedOptions.id,
                    newValue);
            self.dashboardDataService.updatePanelOptions(updatedOptions); // why two sources of truth?
        }
    },

    onPanelOptionsUpdatedSignal: function (updatedOptions) {
        let self = this;
        // short circuit if permalink
        if (self.route().link) {
          return;
        }
        let found = _.find(ko.unwrap(self.panelsOA), ["id", updatedOptions.id]);
        let foundFixed = _.find(ko.unwrap(self.fixedPanels), ["id", updatedOptions.id]);

        if (found) {
            // found has already been updated just need to persist it
            let unwrap = self.getDashboardIds(updatedOptions.id);
            if (!unwrap) return; // invalid panel id, skip the rest
            PreferenceService
                .addOrUpdatePanel(unwrap.appId,
                    unwrap.viewId,
                    unwrap.tabId,
                    updatedOptions.id,
                    getJsonFromComponent(found));
        } else if (foundFixed) {
            // fixed panels not tied to  panelToTab, skip getDashboardIds function and call observable directly
            let unwrap = ko.unwrap(self.dashboardIds);
            if (!unwrap) return; // invalid panel id, skip the rest
            PreferenceService
                .updateFixedPanel(unwrap.appId,
                    unwrap.viewId,
                    unwrap.tabId,
                    updatedOptions.id,
                    getJsonFromComponent(foundFixed));
        } else {
            console.error('Attempted to update non-existing panel: ' + updatedOptions.id);
        }
    },

    onPanelsPositionsUpdated: function (panels) {
        var self = this;
        // short circuit if permalink
        if (self.disallowTabEditing()) {
          return;
        }
        var unwrap = self.getDashboardIds(_.head(_.map(panels, 'id')));
        if (!unwrap) return; // invalid panel id, skip the rest
        PreferenceService.addOrUpdatePanels(unwrap.appId, unwrap.viewId, unwrap.tabId, panels);
        self.dashboardDataService.updatePanelPositions(panels);  // why two sources of truth?

        _.forEach(panels, function (panel) { // why two sources of truth?
            let found = _.find(ko.unwrap(self.panelsOA),  ['id', panel.id]);
            if (found) {
                found.x = panel.x;
                found.y = panel.y;
            }
        });

    },

    saveTabAdded: function (parameters) {
      let newTab = parameters.tab;
      let callback = parameters.callback;

        var self = this;
        // short circuit if permalink
        if (self.disallowTabEditing()) {
          return;
        }
        var unwrap = self.getDashboardIds();
        PreferenceService.addTab(unwrap.appId, unwrap.viewId, newTab.id,  newTab).then(function() {
          if (callback) callback();
          setDashboardsAndTabsList(self);
        });
    },

    saveTabRemoved: function (tabId) {
        var self = this;
        // short circuit if permalink
        if (self.disallowTabEditing()) {
          return;
        }
        var unwrap = self.getDashboardIds();
        PreferenceService.deleteTab(unwrap.appId, unwrap.viewId, tabId).then(() => {
          setDashboardsAndTabsList(self);
        });
    },

    saveRenameTab: function (params) {
        var self = this;
        // short circuit if permalink
        if (self.disallowTabEditing()) {
          return;
        }
        var unwrap = self.getDashboardIds();
        PreferenceService.renameTab(unwrap.appId, unwrap.viewId, params.id, params.name).then(() => {
          setDashboardsAndTabsList(self);
        });
    },

    showAddPanelsModal: function () {
        var self = this;

        //  TODO: UI-1334 add panel when user confirms creation
        //  TODO:  (do not wait until closes "add panel" modal)
        AddPanelModal
            .showModal()
            .then(function(optionsSet) {
              self.addPanels(optionsSet);
            });
    },

  getDashboardIds: function (panelId) {
    let self = this;
    let unwrap = _.assign({}, ko.unwrap(self.dashboardIds));
    if (panelId && self.panelToTab[panelId]) {
      unwrap.tabId = self.panelToTab[panelId];
    } else if (panelId) {
      // return undefined if panel is no longer valid
      return;
    }
    return unwrap;
  },

  internalSetPanels: function (panels) {
    let self = this;
    // update panelToTab map used by getDashboardIds
    self.panelToTab = {};
    _.forEach(panels, panel => {self.panelToTab[panel.id] = ko.unwrap(self.dashboardIds).tabId});
    self.panelsOA(panels);
  },

  setPanels: function(panels) {
      let self = this;
      self.internalSetPanels(panels);
      self.dashboardDataService.setPanels(ko.unwrap(self.panelsOA));

      self.selectedDashboard({
          dateRange: self.dateRange,
          panelsOA: self.panelsOA,
          signals: self.panelSignals
      });
    },

    processTabFixedPanels: function (panels) {
        let self = this;
        let panelCopy = panels.slice(0).map((panel) => {
          panel.params.options.id = panel.id;
        });

        self.fixedPanels([]); // clear panels so they get disposed and subscriptions are removed - alternatively... calls dispose manually on each
        
        self.createComponents(panels).then(function(processedPanels) {
          self.fixedPanels(processedPanels.sort(function(left, right) {
            return left.seq > right.seq ? 1 : -1;
          }));
        });
    },

    processTabPreferences: function (panels) {
        var self = this;
        if (self.usesCommonWidget()) {
          self.setPanels([]); // clear panels so they get disposed and subscriptions are removed - alternatively... calls dispose manually on each

          self.createComponents(panels).then(function(processedPanels) {
            self.setPanels(processedPanels);
          });
        } else {
          self.setPanels(panels);
        }
    },

    processViewPreferences: function (prefs) {
        var self = this,
            unwrap = ko.unwrap(self.dashboardIds);
        if (_.isNil(prefs)) {
            prefs = [];
        }
        // TODO: Trunks tab doesn't come from preferences. Eventually this should be generic.
        if (unwrap.appId === 'historical2' && unwrap.viewId === 'historical2infrastructure' // todo??
            && prefs.length < 2) {
          prefs.push({
            name: "Trunks",
            id: "1" // id must be a string
          });
        }
        self.tabsList(prefs);
    },

    usesCommonWidget: function() {
      let appId = ko.unwrap(this.dashboardIds).appId;
      return appId === 'historical2' || appId === 'rooms';
    },

    // This whole function is adapted from dashboard-common and prepares parameters for common-widget
    createComponents: function(dashboardOptions) {
      var self = this;
      let promise = new Promise((resolve, reject) => {
        if (dashboardOptions.length === 0) {
          resolve([]);
          return;
        }
        let newDashboardOptions = [];
        let count = 0;
        let maxCount = dashboardOptions.length;
        // historical2 panels are built from panel-factory and use the 'common-widget' component rather than the 'panel' component.
        // This code is copied/adapted from dashboard-common.
        dashboardOptions.forEach(function(currentOption) {
          if (!currentOption.id || !currentOption.params) { // todo we should delete from prefs db the ones without params
              count++;
              if (count <= maxCount) {
                resolve(newDashboardOptions);
              }
              return;
          }
          let template = $.extend(true, {}, self.panelFactory.getPanelFromType(currentOption.type));
          let panel = $.extend({}, template);
          let options = $.extend({}, template.defaultOptions, currentOption.params.options);
          options.viewLevelOptions = self.viewLevelOptions;

          if (options.id !== currentOption.id) { // todo we should save the fixed panel to db
            console.log('repairing panel', currentOption.id);
            options.id = currentOption.id;
          }

          panel.observableOptions = ko.observable(options);

          let observableParamsList = makeObservableParams(panel);
          if (observableParamsList && !$.isEmptyObject(observableParamsList)) {
            for (let j=0; j < panel.dataSources.length; j++) {
                if (panel.dataSources[j].params.observableParams) {
                    panel.dataSources[j].observableParams = observableParamsList[j];
                }
            }
          }

          let dataConsumerObject = { id: panel.observableOptions().id, observableOptions: panel.observableOptions };

          self.dataProvider.registerDataConsumer(dataConsumerObject, panel.dataSources, panel.dataFormatter)
          let dataHandle = self.dataProvider.getObservableData(dataConsumerObject);
          self.dataConsumers.push(dataConsumerObject.id);
          let component = {
            id: panel.observableOptions().id,
            name: panel.widgetType,
            componentType: panel.panelType,
            params: {
                observableData: dataHandle,
                observableOptions: panel.observableOptions,
                panelTemplate: panel,
                deletedSignal: new Signals.Signal(),
                optionsSignal: new Signals.Signal(),
                resizeSignal: new Signals.Signal(),
                titleSignal: new Signals.Signal(),
                clonePanelSignal: new Signals.Signal(),
                movePanelSignal: new Signals.Signal(),
                copyPanelSignal: new Signals.Signal(),
                copyPanelAdvancedSignal: new Signals.Signal()
            },
            height: panel.height,
            width: panel.width
          };

          component.params.deletedSignal.add(function(id) { self.onPanelDeleted(id); });
          component.params.optionsSignal.add(function(options) {
            self.onPanelOptionsUpdatedSignal(options);
          });
          component.params.titleSignal.add(function(options) {
            let unwrap = self.getDashboardIds(options.id);
            if (!unwrap) return; // invalid panel id, skip the rest
            PreferenceService.addOrUpdatePanelTitle(unwrap.appId,
                unwrap.viewId,
                unwrap.tabId,
                options.id,
                options.panelHeader);
          });
          component.params.clonePanelSignal.add(function(panelTemplate, panelOptions) {
            self.addPanelCallback(panelTemplate, panelOptions);
          })
          component.params.movePanelSignal.add(function(viewId, targetTab, panelId, panelTemplate, panelOptions) {
            // short circuit if permalink
            if (self.disallowTabEditing()) {
              return;
            }
            let newPanel = createHistorical2Panel(panelTemplate, panelOptions);
            delete newPanel.autoPosition;
            PreferenceService.addOrUpdatePanel(self.dashboardIds().appId,
                viewId,
                targetTab.id,
                newPanel.id,
                newPanel).then(() => {
                  self.onPanelDeleted(panelId).then(() => {
                    self.notificationBarText(`"${newPanel.params.options.panelHeader}" Panel has been moved to "${targetTab.name}" Dashboard`);
                    self.notificationBar.classList.add('show-notification-bar');
                    setTimeout(() => { self.notificationBar.classList.remove('show-notification-bar'); }, 3000); // show for 3 seconds
                  });
                });
          });
          component.params.copyPanelSignal.add(function() {
            // short circuit if permalink
            if (self.disallowTabEditing()) {
              return;
            }
            let modal = ko.dataFor($('#share-panel-modal')[0].firstChild);
            let unwrap = self.getDashboardIds();

            modal.show({
              appId: unwrap.appId,
              viewId: unwrap.viewId
            });
          });
          component.params.copyPanelAdvancedSignal.add(function() {
            let modal = ko.dataFor($('#share-panel-adv-modal')[0].firstChild);
            let unwrap = self.getDashboardIds();

            modal.show({
              appId: unwrap.appId,
              viewId: unwrap.viewId
            });
          });

          component.x = currentOption.x;
          component.y = currentOption.y;
          component.params.observableParamsList = observableParamsList;
          component.params.viewLevelOptions = self.viewLevelOptions;
          component.seq = currentOption.seq;

          if (self.disallowTabEditing()) {
            component.params.panelTemplate.hideControls = true;
          }

          newDashboardOptions.push(component);

          count++;
          if (count <= maxCount) {
            resolve(newDashboardOptions);
          }
        });
      });

      return promise;
    }
};

function handleRoute(self, route, params) {
  if (route.link) {
    self.allowNewTab(false);
    self.disallowTabEditing(true);
    self.disableDrag(true);
  } else {
    self.allowNewTab(!!params.allowNewTab);
    self.disallowTabEditing(!!params.disallowTabEditing);
    self.disableDrag(!self.permissionService.hasPermission(self.permissionService.DashboardEditPermission));
  }

  self.dashboardIds({
    appId: params.appId,
    viewId: ko.unwrap(params.viewId)
  });

  // todo: this is causing issues but should be called
  if (!route.link) {
    dispatchTabChanged(self, route.tabId);
  }
}
function dispatchTabChanged(self, tabId) {
    if (self.selectedTabChanged && typeof self.selectedTabChanged.dispatch === 'function') {
      self.selectedTabChanged.dispatch(tabId);
    }
}

export default TabbedDashboardVM;


ko.components.register('tabbed-dashboard', { template: templateMarkup, viewModel: TabbedDashboardVM });
